export const personalEmails = [
    'gmail.com',
    'gmail.com.br',
    'gmail.ru',
    'yaho.com',
    'yahoo.ae',
    'yahoo.at',
    'yahoo.be',
    'yahoo.ca',
    'yahoo.ch',
    'yahoo.cn',
    'yahoo.co',
    'yahoo.co.id',
    'yahoo.co.il',
    'yahoo.co.in',
    'yahoo.co.jp',
    'yahoo.co.kr',
    'yahoo.co.nz',
    'yahoo.co.th',
    'yahoo.co.uk',
    'yahoo.co.za',
    'yahoo.com',
    'yahoo.com.ar',
    'yahoo.com.au',
    'yahoo.com.br',
    'yahoo.com.cn',
    'yahoo.com.co',
    'yahoo.com.hk',
    'yahoo.com.is',
    'yahoo.com.mx',
    'yahoo.com.my',
    'yahoo.com.ph',
    'yahoo.com.ru',
    'yahoo.com.sg',
    'yahoo.com.tr',
    'yahoo.com.tw',
    'yahoo.com.vn',
    'yahoo.cz',
    'yahoo.de',
    'yahoo.dk',
    'yahoo.es',
    'yahoo.fi',
    'yahoo.fr',
    'yahoo.gr',
    'yahoo.hu',
    'yahoo.ie',
    'yahoo.in',
    'yahoo.it',
    'yahoo.jp',
    'yahoo.nl',
    'yahoo.no',
    'yahoo.pl',
    'yahoo.pt',
    'yahoo.ro',
    'yahoo.ru',
    'yahoo.se',
    '163.com',
    '126.com',
    'qq.com',
    'yeah.net',
    'vip.126.com',
    'vip.21cn.com',
    'vip.citiz.net',
    'vip.gr',
    'vip.onet.pl',
    'vip.qq.com',
    'vip.sina.com',
    'sina.com',
    '188.com',
    '189.cn',
    'cntv.cn',
    'msm.cn',
    'hotmail.ca',
    'hotmail.ch',
    'hotmail.co',
    'hotmail.co.il',
    'hotmail.co.jp',
    'hotmail.co.nz',
    'hotmail.co.uk',
    'hotmail.co.za',
    'hotmail.com',
    'hotmail.com.au',
    'hotmail.com.br',
    'hotmail.com.tr',
    'hotmail.de',
    'hotmail.es',
    'hotmail.fi',
    'hotmail.fr',
    'hotmail.it',
    'hotmail.kg',
    'hotmail.kz',
    'hotmail.nl',
    'hotmail.ru'
];

export const emailRe =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const passwordRe =
  /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()_+<>?":`,./;'[\]=\-|\\{}]{8,32}$/;

export const isValidEmail = function(value: string) {
    return emailRe.test(value);
};

export const isPersonalEmail = function(value: string) {
    return personalEmails.find((email) => value.includes(email));
};

export const isValidPassword = function(value: string) {
    return passwordRe.test(value);
};
